import { Stack, Typography } from '@mui/material';
import { FC } from 'react';
import { useSelector } from 'react-redux';

import { gettext } from 'medialoopster/Internationalization';

import { annotationSelectors } from '../../../../state/modules/annotation';
import AnnotationsActionMenu from './AnnotationsActionMenu';
import ShowAllSwitch from './ShowAllSwitch';

// TODO: The design of the header, especially the bottom border, is shared with the TranscriptHeader <KH 2024-08-28 t:ML-3549>

/** Component to render the header of the Annotations panel
 *
 * The Header holds a title, the switch for showing only comments created by the user and
 * the "hamburger menu" button.
 */

const AnnotationsPanelHeader: FC = () => {
  const hasAnnotationPermission = useSelector(annotationSelectors.hasAnnotationPermission);

  return (
    <Stack
      direction="row"
      sx={{
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'nowrap',
        py: 1,
        pl: 4,
        borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
      }}
    >
      <Typography>{gettext('Annotations')}</Typography>
      {/* Controls should be distributed to the right with a minimum spacing to the Title */}
      <Stack
        direction="row"
        sx={{
          ml: 'auto',
          pl: 4,
          justifyContent: 'flex-end',
          alignItems: 'center',
        }}
      >
        <ShowAllSwitch />
        {hasAnnotationPermission && <AnnotationsActionMenu />}
      </Stack>
    </Stack>
  );
};

export default AnnotationsPanelHeader;
